module.exports = __webpack_public_path__ + "img/training.29527d6b.svg";